<div class="loading-container" *ngIf="showSpinner">
  <div class="loading-gif">
    <img src="../assets/images/Spinner.gif">
  </div>
</div>

<div class="row mb-2">
  <div class="col-sm-4">
    <button type="button" class="btn btn-primary btn-md btn-block" (click)='onAccrualDownloadClick()' name="onAccrualDownloadClick">Download Accrual File</button>
    <button type="button" class="btn btn-primary btn-md btn-block" (click)='onValidationDownloadClick()' name="onValidationDownloadClick">Download Validation File</button>
    <button type="button" class="btn btn-primary btn-md btn-block" (click)='onClientMappingFileDownloadClick()' name="onClientMappingFileDownloadClick">Download Client Mapping File</button>
  </div>

  <div class="col-sm-3 offset-sm-1">
    <h4>GTV Charge Category Lookup</h4>

    <div class="form-group row">
      <label class="col-4 col-form-label">Category Name</label>
      <div class="col-8"><input type="text" class="form-control" [(ngModel)]="chargeCategoryName" (keyup.enter)="onGtvChargeCategoryLookup()" /></div>
    </div>
    <button type="button" class="btn btn-primary" [disabled]="chargeCategoryName.trim() === ''" (click)="onGtvChargeCategoryLookup()">Get GTV ID</button>
    
    <div class="mt-5 gtv-charge-error">{{chargeCategoryErrorMessage}}</div>

    <div class="row mt-5" *ngFor="let result of chargeCategoryResults">
      <div class="col-8 font-weight-bold">{{result.name}}</div>
      <div class="col-4">{{result.id}}</div>
    </div>
  </div>
</div>